<div class="payment-return-page" [ngStyle]="backgroundImageUrl ? {'background-image':'url(' + backgroundImageUrl + ')'} : {}">
  <div class="payment-return-card">
    <img *ngIf="logoImageUrl" class="payment-return-logo" [src]="logoImageUrl" alt="Logo"/>

    <div class="payment-return-message">
      <div *ngIf="hasStatusCreated">
        <h4 [ngStyle]="headingTextStyle">{{ 'paymentRedirected.paymentCreatedTitle' | translate }}</h4>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRedirected.paymentCreatedText' | translate: payment }}</p>
      </div>

      <div *ngIf="hasStatusInProgress">
        <h4 [ngStyle]="headingTextStyle">{{ 'paymentRedirected.paymentInProgressTitle' | translate }}</h4>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRedirected.paymentInProgressText' | translate: payment }}</p>
      </div>

      <div *ngIf="hasStatusCompleted">
        <h4 [ngStyle]="headingTextStyle">{{ 'paymentRedirected.paymentCompletedTitle' | translate }}</h4>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRedirected.paymentCompletedText' | translate: payment }}</p>
      </div>

      <div *ngIf="hasStatusCanceled">
        <h4 [ngStyle]="headingTextStyle">{{ 'paymentRedirected.paymentCanceledTitle' | translate }}</h4>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRedirected.paymentCanceledText' | translate: payment }}</p>
      </div>

      <div *ngIf="hasStatusFailed">
        <h4 [ngStyle]="headingTextStyle">{{ 'paymentRedirected.paymentErrorTitle' | translate }}</h4>
        <p [ngStyle]="bodyTextStyle">{{ 'paymentRedirected.paymentErrorText' | translate: payment }}</p>
      </div>
    </div>

    <div class="payment-return-details" [ngStyle]="bodyTextStyle">
      <h4 class="payment-return-section-title" [ngStyle]="headingTextStyle">
        {{ 'paymentRedirected.paymentDetailsHeader' | translate }}
      </h4>

      <div class="payment-return-detail-field">
        <span class="payment-return-detail-title">{{ 'paymentRedirected.companyNameFieldLabel' | translate }}</span>
        <span class="payment-return-detail-value">{{ payment.CompanyName }}</span>
      </div>

      <div class="payment-return-detail-field">
        <span class="payment-return-detail-title">{{ 'paymentRedirected.companyIbanFieldLabel' | translate }}</span>
        <span class="payment-return-detail-value">{{ payment.CompanyIban }}</span>
      </div>

      <div class="payment-return-detail-field">
        <span class="payment-return-detail-title">{{ 'paymentRedirected.remittanceInformationFieldLabel' | translate }}</span>
        <span class="payment-return-detail-value">{{ payment.RemittanceInformation }}</span>
      </div>

      <div class="payment-return-detail-field">
        <span class="payment-return-detail-title">{{ 'paymentRedirected.amountCurrencyFieldLabel' | translate }}</span>
        <span class="payment-return-detail-value">{{ payment.AmountCurrency }}</span>
      </div>
    </div>
  </div>
</div>
